import { DrawToolStyleSection } from 'components/minute/sidebar/ToolSidebar/DrawToolSidebar/DrawToolStyleSection';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const DrawToolSidebar = (props: Props): JSX.Element => {
    return (
        <S_DrawToolSidebar className={props.className}>
            <DrawToolStyleSection />
        </S_DrawToolSidebar>
    );
};

const S_DrawToolSidebar = styled.div`
    width: 100%;
`;
